import React, { ReactElement, ReactNode, useEffect, useRef } from 'react';
import { Helmet } from 'react-helmet-async';
import { useParams } from 'react-router-dom';
import { Theme } from '@kb-front/ui-kit';
import { Footer, Header } from 'birbank-additional';
import { ELang } from 'shared/enum';

interface LayoutProps {
  children: ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }): ReactElement => {
  const { lang = ELang.AZ } = useParams();
  const headerRef = useRef<HTMLDivElement>(null);
  const footerRef = useRef<HTMLDivElement>(null);
  const BASE_URL = 'https://ccl.birbank.az';
  const ORDER_PATH = '/order/GTKR';

  useEffect(() => {
    headerRef.current?.classList.remove('hide-until-mounted');
    footerRef.current?.classList.remove('hide-until-mounted');
  }, []);

  return (
    <Theme.Provider>
      {({ theme }) => (
        <Theme theme={theme}>
          <Helmet>
            <link rel="canonical" href={`${BASE_URL}/${lang}${ORDER_PATH}`} />
            <link rel="alternate" hrefLang="az" href={`${BASE_URL}/az${ORDER_PATH}`} />
            <link rel="alternate" hrefLang="en" href={`${BASE_URL}/en${ORDER_PATH}`} />
            <link rel="alternate" hrefLang="ru" href={`${BASE_URL}/ru${ORDER_PATH}`} />
            <link rel="alternate" hrefLang="x-default" href={`${BASE_URL}/${lang}${ORDER_PATH}`} />
          </Helmet>
          <div>
            <div ref={headerRef} className="hide-until-mounted">
              <Header />
            </div>
            <main>{children}</main>
            <div ref={footerRef} className="hide-until-mounted">
              <Footer />
            </div>
          </div>
        </Theme>
      )}
    </Theme.Provider>
  );
};

export default Layout;
